import { Cell } from "./Cell";
import { getStatusClass } from "features/videoUploads/functions";
import { DieLigenApiManagementConstants } from "../../pages/productManagement/apiManagement/dieLigen/DieLigenApiManagementConstants";
import { ActionsCell } from "./ActionsCell";
import { _, _any } from "i18n";
import { Keys } from "i18n/locales/types";

interface StatusCellProps {
    value?: string | number | null;
    row?: {
        id?: string;
        original: {
            videoStatus?: string | null;
            teamsheetStatus?: string | null;
            id?: string | number;
        };
    };
    type: 'video' | 'teamsheet';
    onPress?: () => void;
    onTeamsheetClick?: (id: string | number) => void;
}

export const StatusCell: React.FC<StatusCellProps> = ({ value, row, type, onTeamsheetClick }) => {
    const status = value?.toString() ?? '';
    const isActionable = type === 'teamsheet' && (
        row?.original.teamsheetStatus === DieLigenApiManagementConstants.Status.PARTIALLY_MAPPED ||
        row?.original.teamsheetStatus === DieLigenApiManagementConstants.Status.NOT_MAPPED
    );

    const getTranslationKey = (status: string) => {
        return `video-tasks.table.status.${status.toLowerCase()}` as keyof Keys;
    };

    const statusLabel = status ? _(getTranslationKey(status)) : "-";

    if (isActionable) {
        return (
            <ActionsCell
                actions={[
                    {
                        type: 'button',
                        label: statusLabel,
                        className: `secondary ${getStatusClass(status)}`,
                        onClick: () => {
                            if (onTeamsheetClick && row?.id) {
                                onTeamsheetClick(row.id);
                            }
                        }
                    }
                ]}
            />
        );
    }

    return (
        <Cell variant="data">
            <div className={getStatusClass(status)}>
                {statusLabel}
            </div>
        </Cell>
    );
}; 